<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <el-form id="elForm" :model="formInline" ref="formInline" :inline="true" label-position="right"  class="demo-form-inline" label-width="96px" size="medium">
              <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                  <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                <el-select v-model="formInline.countryID" placeholder="请选择区" @change="selectChange(2,formInline.countryID)">
                  <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="幼儿园：" prop="kindOrgID">
                <el-select v-model="formInline.kindOrgID" placeholder="请选择幼儿园" filterable>
                    <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="性别：">
                <el-select v-model="formInline.sex" placeholder="请选择性别">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option key="男" label="男" value="男"></el-option>
                    <el-option key="女" label="女" value="女"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="身份证号码：">
                <el-input v-model="formInline.idCard"></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input v-model="formInline.childName"></el-input>
            </el-form-item>
            <el-form-item label="联系人：">
                <el-input v-model="formInline.relation"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="relationPhone">
                <el-input v-model="formInline.relationPhone"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="btn-primary" @click="query(formInline)">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="mb15">
              <!-- <el-button @click="AddTo()"><i class="el-icon-edit"></i>&nbsp;添加</el-button>
              <el-button @click="removegGarten()"><i class="el-icon-delete"></i>&nbsp;删除</el-button> -->
              <el-button v-for='(item,index) in generalArea' :key='index' class="btn-outline" @click="doClick(item.operFunc)"  plain>{{item.operName}}</el-button>
          </div>
          <el-table :data="tableData" @select="tableSelect" @select-all="tableSelectAll" class="table-bordered" style="width: 100%;" v-loading="tableLoading" element-loading-text="拼命加载中">
            <el-table-column type="selection" current-row-key="childID" width="55"></el-table-column>
            <el-table-column prop="childName" label="姓名"></el-table-column>
            <el-table-column prop="sex" label="性别"></el-table-column>
            <el-table-column prop="birthday" label="生日"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="fullName" label="所属幼儿园" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idCard" label="身份证号码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="relation" label="联系人"></el-table-column>
            <el-table-column prop="relationPhone" label="手机号码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="street" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width='170'>
                <template slot-scope="scope">
                  <!-- <el-button class="btn-primary btn-outline" @click="editAccount(scope.$index,scope.row)" size="small" plain><i class="el-icon-edit-outline"></i>修改</el-button>
                  <el-button class="btn-warning btn-outline" @click="goDetail(scope.$index,scope.row)" size="small" plain><i class="el-icon-document"></i>详情</el-button> -->
                  <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                </template>
            </el-table-column>
          </el-table>
          <!--分页-->
          <el-pagination :current-page="formInline.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="formInline.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
              @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top: 10px;">
          </el-pagination>
          <!--彈出的添加-->
          <el-dialog :visible.sync="dialogTableVisible" :center="true" :before-close="handleClose" :close-on-click-modal='false'>
            <router-view v-on:close="close" v-if='dialogTable'></router-view>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
import {
  Row,
  Table,
  Button,
  Breadcrumb,
  Form,
  FormItem,
  Input,
  Select
} from 'element-ui'

export default {
  name: 'app',
  data () {
    return {
            // 对象属性
      formInline: {
        kindOrgID: '',
        sex: '',
        idCard: '',
        childName: '',
        relation: '',
        relationPhone: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [], // 加载出来的表格数据
      tableSelection: [], // 数据表选择数据集合
      tableSelectObj: {}, // 数据表单条选择数据对象
      tableSelectKey: '',
      total_rows: 0,
      tableLoading: false,
      dialogTableVisible: false,
      dialogTable: true,
      selectpro: [], // 筛选条件下拉框省数据
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据
      show: {
        selCountry: false,
        selCity: false
      },
      idCard: '',
      childName: '',
      sex: '',
      birthday: '',
      kindOrgName: '',
      relation: '',
      relationPhone: '',
      street: '',
      generalArea:[],
      listArea:[]
    }
  },
  methods: {
    selectChange (type, parentID) { // 下拉框值改变事件  type=1市下拉框的值改变事件   type=2区下拉框的值改变事件
      if (type === 1) {
        this.selectarea = [{id: '', name: '全部'}]
        if (parentID !== '') {
          this.getList('common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        this.formInline.countryID = ''
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.kindOrgID = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: ''}, 'selectGarden', true)
      } else if (type === 2) {
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.kindOrgID = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: parentID}, 'selectGarden', true)
      }
    },
    getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (isOrg) {
          that[key + ''].splice(0, 0, {orgKindID: '', fullName: '全部'})
        } else {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        }
      })
    },
    handleClose () {
      let that = this
      that.dialogTableVisible = false
      that.dialogTable = false
    },
    close (flag, refresh) {
      let that = this
      that.dialogTableVisible = flag
      that.dialogTable = flag
      if (refresh == true) {
        that.getOrgs(that.formInline)
      }
    },
    tableSelect (selection, val) { // 表格选中事件
      this.tableSelection = selection
      this.tableSelectObj = val
    },
    tableSelectAll (selection) {
      this.tableSelection = selection
    },
    AddTo (url) { // 添加按钮
      this.dialogTableVisible = true
      this.$router.push({ path: '/childsmgr/add' })
      this.dialogTable = true
    },
    editAccount (index, row) { // 修改按钮
      this.dialogTableVisible = true
      this.$router.push({ path: '/childsmgr/edit/' + row.childID })
      this.dialogTable = true
        // var that = this;
        // if (that.tableSelection.length == 0) {
        //   that.showMsgTip('请选择一条数据！', 'false');
        // } else if (this.tableSelection.length > 1) {
        //   that.showMsgTip('只能选择一条数据！', 'false');
        // } else {
        //   that.dialogTableVisible = true
        //   that.$router.push({ path: '/childsmgr/edit/'+that.tableSelectObj.childID });
        // }
    },
    removegGarten () { // 删除按钮
      if (this.tableSelection.length == 0) {
        this.showMsgTip('错误！您没有选择任何数据', 'false')
      } else if (this.tableSelection.length > 1) {
        this.showMsgTip('请选择一条需要删除的儿童！', 'false')
      } else {
        this.$confirm('您确定要删除所选择的儿童吗？如果已被引用，将无法删除。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.operation()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    operation () { // 删除
      var result = ''
      var self = this
      self.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.childID
        } else {
          result = result + ',' + i.childID
        }
      })
      api.post(config.host + 'child/deleteChild.do', { 'childID': result }).then(function (response) {
        if (response.success === true) {
          self.$message.success('操作成功')// 提示用户
          self.query(self.formInline)
        } else {
          self.$message.error(response.msg)
        }
      })
    },
    showMsgTip (value, type) { // 提示消息
      if (type == 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    pageSizeChange (val) { // 每页显示条数
      this.formInline.pageSize = val

      this.formInline.keyWord = this.keyWord

      this.getOrgs(this.formInline)
    },
    pageCurrentChange (val) { // 分页
      this.formInline.pageNum = val

      this.formInline.keyWord = this.keyWord

      this.getOrgs(this.formInline)
    },
    query (param) { // 查询按钮
      param.pageNum = 1
      this.formInline.keyWord = this.keyWord
      this.getOrgs(this.formInline)
    },

    getOrgs (param) { // 获取页面列表
      let self = this
      api.post(config.host + 'child/getChildList.do', param).then((data) => {
        if (data.success == true) {
          self.formInline.keyWord = this.keyWord

          self.tableData = data.body.list

          self.total_rows = data.body.page.total
          self.tableSelection = [] // 数据表选择数据集合
          self.tableSelectObj = {} // 数据表单条选择数据对象
        }
      })
    },
    goDetail (index, row) { // 详情
      this.dialogTableVisible = true

      this.$router.push({path: '/childsmgr/childDetail/' + row.childID, query: { list: row }})
      this.dialogTable = true
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'doModify':this.editAccount(index,row);break
       case 'showDetail':this.goDetail(index,row);break
       case 'doDelelte':this.removegGarten();break
       case 'doAdd':this.AddTo();break
      }
    }
  },
  created: function () {
    let that = this
        // 创建完毕状态
    api.post(config.host + 'child/getChildList.do', { 'pageNum': 1, 'pageSize': 10 }).then((data) => {
      if (data.success === true) {
        that.formInline.keyWord = this.keyWord

        that.tableData = data.body.list

        that.total_rows = data.body.page.total
        that.tableSelection = [] // 数据表选择数据集合
        that.tableSelectObj = {} // 数据表单条选择数据对象
      }
    })
    api.get(config.host + 'org/getOrgDetail.do').then(function (json) {
      if (json.success === true) {
        if (json.body.scopeType === 1) { // 当前账号是省级妇保院
          that.show.selCity = true
          that.show.selCountry = true
          that.selectcity = [{id: '', name: '全部'}]
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.provinceID }, 'selectcity')
          // that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID}, 'selectGarden', true)
        } else if (json.body.scopeType === 2) { // 当前账号是市级妇保院
          that.show.selCountry = true
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID}, 'selectGarden', true)
        } else if (json.body.scopeType === 3) { // 当前账号是区级妇保院/街道级妇保
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID, countryID: json.body.countryID}, 'selectGarden', true)
        } else if (json.body.scopeType === 4) {
          that.getList('orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
        }
      }
    })
    // api.post(config.host + 'orgkind/getGardenListByOrganId.do').then((data) => {
    //   if (data.success == true) {
    //     self.selectKind = data.body.list
    //   }
    // })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  }
}
</script>

<style>
.line_b_black {
  border-bottom: 1px solid #99a9bf;
  background-color: #fff;
}

.nav {
  height: 3rem;
}

.el-row {
  padding: 5px;
}
.el-table__body, .el-table__footer, .el-table__header {
    table-layout: auto;
}
.el-table th{/*表头加背景色*/
    background:#F5F5F5 !important;
    font-size:15px;
}
.ibox-content{
    padding: 15px 20px 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/childmgr/childsmgr.vue?71ca4550